export const calculateOutstanding = (data: any[], transaction_type?: string, totalBalance?: any) => {
  if (!Array.isArray(data)) {
    return { dataArr: [], totalAmount: 0 };
  }

  const copy = [...data];
  let outstanding = totalBalance ?? 0;

  const newArr = copy.map((item) => {
    let amt = 0;

    if (transaction_type === 'percent') {
      // if item.amount is %, convert it
      amt = (Number(item.amount) / 100) * (totalBalance ?? 0);
    } else {
      amt = Number(item.amount) || 0;
    }

    outstanding -= amt;

    return {
      ...item,
      amount: amt, // replace % with actual amount
      balance: outstanding < 0 ? 0 : outstanding, // safety clamp
    };
  });

  const totalAmount = newArr.map((item) => Number(item.amount) || 0).reduce((prev, next) => prev + next, 0);

  return {
    dataArr: newArr,
    totalAmount,
  };
};

export const calculateAmountOutstanding = (data: any[], totalBalance: any) => {
  const copy = [...data];

  let outstanding = totalBalance;

  const newArr = copy.map((data) => {
    outstanding -= Number(data.amount);
    return {
      ...data,
      balance: outstanding,
    };
  });

  const totalAmt = newArr.map((item) => (item.amount ? Number(item.amount) : 0)).reduce((prev, next) => prev + next);
  const totalFee = newArr
    .map((item) => Number(item.fee ?? item.cf_amount ?? item.con_fee ?? 0) || 0)
    .reduce((prev, next) => prev + next);
  return {
    dataArr: newArr,
    totalAmount: totalAmt,
    totalFee: totalFee,
  };
};

export const CalculateCustomAmount = (data: any, rowIdx: number, inputValue?: any, totalBalance?: any) => {
  const copy = [...data];
  // Update value in Array
  if (rowIdx === 0) {
    copy[rowIdx].balance = totalBalance - copy[rowIdx].amount;
  } else {
    data[rowIdx].balance = copy[rowIdx > 0 ? rowIdx - 1 : 0].balance - copy[rowIdx].amount;
  }
  // Update all Array
  const tmpData = [...copy].map((itm, idx) => {
    if (idx > 0) {
      return {
        ...itm,
        balance: copy[idx - 1].balance - itm.amount,
      };
    } else {
      return {
        ...itm,
        balance: totalBalance - itm.amount,
      };
    }
  });

  const totalAmt = tmpData.map((item) => (item.amount ? Number(item.amount) : 0)).reduce((prev, next) => prev + next);
  return {
    dataArr: tmpData,
    totalAmount: totalAmt,
  };
};

export const CalculateCustomPercentage = (data: any, rowIdx: any, inputPercentage: any, totalBalance: any) => {
  const copy = JSON.parse(JSON.stringify(data));
  let outstanding = totalBalance;
  let total: any = [];
  const tmpData = copy.map((el: any) => {
    const diff = percentageToAmount(totalBalance, el.amount);
    total.push(diff);
    const currBalance = outstanding - diff;
    outstanding -= diff;
    return { ...el, amount: el.amount, balance: currBalance.toFixed(2), fee: el.fee, payment_date: el.payment_date };
  });
  const totalAmt = total.reduce((prev: any, next: any) => prev + next);
  const totalFee = copy
    .map((item: any) => (item.fee ? Number(item.fee) : 0))
    .reduce((prev: any, next: any) => prev + next);
  return {
    dataArr: tmpData,
    totalAmount: totalAmt.toFixed(2),
    amountArray: total,
    totalFee: totalFee,
  };
};

const percentageToAmount = (totalAmount: any, percentage: any) => {
  const amount = (Number(totalAmount) * Number(percentage)) / 100;
  return amount;
};

export const averageAmount = (totalAmount: number, noOfTransaction: number) => {
  const avg = (Number(totalAmount) / Number(noOfTransaction)).toFixed(2);
  return avg;
};
